<template>
  <div class="task">
    <div class="task-title">任务中心</div>
    <div class="task-select">
      <div class="task-select-left">
        <div class="tab-item" v-for="(data,index) in itemList" :key="index" @click="changeBg(index,data)" :class="{'top-crib-title-num-active': data.sign === 1}">
          {{data.title}}
        </div>
      </div>
      <div class="task-select-right">
        <div class="input-date-wrapper">
          <el-date-picker
            v-model="value"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
        <div class="query button" @click="handleSearch(1)">查询</div>
        <div class="four-font-wrapper" style="margin-left: 1vw" @click="toRelease"><div class="icon-font">&#xe678;</div>发布任务</div>
      </div>
    </div>
    <div class="task-delete">
      <div class="four-font-wrapper" @click="deleteAll">
        <div class="icon-font">&#xe646;</div>批量删除
      </div>
    </div>
    <div class="task-content">
      <div class="detail">
        <div class="detail-box">
          <div class="loading-data" v-if="loading">
            <i class="el-icon-loading"></i>
            <div>加载中，请稍后···</div>
          </div>
          <div class="detail-nav">
            <div class="detail-item" style="width: 10%">
              <div class="select-icon" :class="{'select-icon-active': all}" @click="selectAll"></div>
            </div>
            <div class="detail-item" style="width: 10%">任务编号</div>
            <div class="detail-item" style="width: 10%">任务类型</div>
            <div class="detail-item" style="width: 15%">发起时间</div>
            <div class="detail-item" style="width: 20%">任务详情</div>
            <div class="detail-item" style="width: 15%">状态</div>
            <div class="detail-item" style="width: 20%">操作</div>
          </div>
          <div class="detail-content" v-if="!loading">
            <div class="detail-list-wrapper" v-if="!loading && tableData.length>0" v-for="(data,index) in tableData" :key="index">
              <div class="detail-item" style="width: 10%">
                <div class="select-icon" :class="{'select-icon-active': data.sign === 1}" @click="selectSingle(data.id)"></div>
              </div>
              <div class="detail-item" style="width: 10%" v-if="data.taskNum">
                <el-popover
                  placement="top"
                  title=""
                  trigger="hover"
                  :content="data.taskNum">
                  <div class="popover" style="width: 8vw;text-align: center" slot="reference">{{data.taskNum}}</div>
                </el-popover>
              </div>
              <div class="detail-item" style="width: 10%">{{data.taskType}}</div>
              <div class="detail-item" style="width: 15%">{{data.createdTime}}</div>
              <div class="detail-item" style="width: 20%">
                <el-popover
                  placement="top"
                  title=""
                  trigger="hover"
                  :content="data.taskDetail">
                  <div class="popover" slot="reference">{{data.taskDetail}}</div>
                </el-popover>
              </div>
              <div class="detail-item color-red" style="width: 15%" :class="{'color-green': data.isDeal}">{{data.isDeal ? '已完成' : '未完成'}}</div>
              <div class="detail-item" style="width: 20%">
                <div class="detail-btn item-audit" style="margin: 0 0.5vw" @click="dealTaskData(data.id)" v-if="!data.isDeal">完成</div>
                <div class="detail-btn item-look-active" style="margin: 0 0.5vw" v-if="data.isDeal">完成</div>
                <div class="detail-btn item-delete" @click="deleteSingle(data.id)">删除</div>
              </div>
            </div>
            <div class="none-data" v-if="!loading && tableData.length<1">暂无数据</div>
          </div>
          <div class="page-wrapper" v-if="!loading && total > rows">
            <div class="page-wrapper-left">共{{total}}条数据，每页显示{{rows}}条，当前第{{page}}页</div>
            <div class="page-wrapper-right">
              <div class="page-btn" @click="firstPage">首页</div>
              <div class="page-btn" @click="previousPage">上一页</div>
              <div class="page-btn" @click="nextPage">下一页</div>
              <div class="page-btn" @click="lastPage">尾页</div>
            </div>
          </div>
        </div>
        <transition name="fade">
          <div class="alert-box" v-if="show">
            <div class="alert-content">
              <div class="alert-content-title">删除提醒</div>
              <div class="alert-content-msg">是否确认删除选中数据?</div>
              <div class="alert-content-btn">
                <div class="btn-cancel button" @click="cancelDelete">取消</div>
                <div class="btn-confirm button" @click="confirmDelete">确认</div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <img class="task-icon" src="../../../assets/content-box.png"/>
  </div>
</template>

<script>
import {queryTaskList, delTask, bathDelTask, dealTask} from '../../../api/maintain'
export default {
  name: 'Task',
  data () {
    return {
      value: '',
      itemList: [
        {title: '全部', sign: 1},
        {title: '已处理', sign: 0},
        {title: '未处理', sign: 0}
      ],
      show: false,
      all: false,
      id: '',
      type: 0,
      idList: [],
      tableData: [],
      loading: true,
      startTime: '',
      endTime: '',
      isDeal: '',
      page: 1,
      rows: 8,
      total: ''
    }
  },
  created () {
    let value = parseInt(this.$route.query.value)
    if (isNaN(value)) {
      value = 0
    }
    if (value === 0) {
      this.isDeal = ''
    } else if (value === 1) {
      this.isDeal = 1
    } else if (value === 2) {
      this.isDeal = 0
    }
    this.itemList.map((data, ind) => {
      if (value === ind) {
        data.sign = 1
      } else {
        data.sign = 0
      }
    })
    this.handleSearch()
  },
  watch: {
    '$route' () {
      let value = parseInt(this.$route.query.value)
      if (isNaN(value)) {
        value = 0
      }
      if (value === 0) {
        this.isDeal = ''
      } else if (value === 1) {
        this.isDeal = 1
      } else if (value === 2) {
        this.isDeal = 0
      }
      this.itemList.map((data, ind) => {
        if (value === ind) {
          data.sign = 1
        } else {
          data.sign = 0
        }
      })
      this.handleSearch(1)
    },
    value: function () {
      this.startTime = this.value !== null ? this.value[0] : ''
      this.endTime = this.value !== null ? this.value[1] : ''
    }
  },
  methods: {
    changeBg: function (index) {
      this.$router.push({
        path: '/task',
        query: {
          index: '9',
          value: index
        }
      })
      this.itemList.map((data, ind) => {
        if (index === ind) {
          data.sign = 1
        } else {
          data.sign = 0
        }
      })
    },
    selectAll: function () {
      this.type = 1
      this.all = !this.all
      let idList = []
      if (this.all) {
        this.tableData.map((data, index) => {
          data.sign = 1
          idList.push(data.id)
        })
        this.idList = idList
      } else {
        this.tableData.map((data, index) => {
          data.sign = 0
          this.idList = []
        })
      }
    },
    selectSingle: function (id) {
      this.tableData.map((data, index) => {
        if (id === data.id) {
          data.sign = data.sign === 1 ? 0 : 1
          if (data.sign === 1) {
            this.idList.push(data.id)
          } else {
            let idList = []
            this.idList.map((item, index) => {
              if (item !== id) {
                idList.push(item)
              }
            })
            this.idList = idList
          }
          console.log(this.idList)
        }
      })
      this.all = this.idList.length === this.tableData.length
    },
    deleteSingle: function (id) {
      this.show = true
      this.id = id
      this.type = 0
    },
    deleteAll: function () {
      if (this.idList.length !== 0) {
        this.show = true
        this.type = 1
      } else {
        this.$message({
          message: '请选择要删除的数据!',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      }
      console.log(this.idList)
    },
    cancelDelete: function () {
      this.show = false
    },
    confirmDelete: function () {
      if (this.type === 0) {
        let body = {
          id: this.id
        }
        console.log(body)
        delTask(body).then(res => {
          console.log(res)
          this.$message({
            message: res.data,
            type: 'success',
            center: 'true',
            duration: '1000'
          })
          this.show = false
          this.id = ''
          this.handleSearch()
        }).catch(err => {
          console.log(err)
        })
      } else {
        let body = {
          idArray: this.idList
        }
        console.log(body)
        bathDelTask(body).then(res => {
          console.log(res)
          this.all = false
          this.idList = []
          this.$message({
            message: res.data,
            type: 'success',
            center: 'true',
            duration: '1000'
          })
          this.show = false
          this.handleSearch()
        }).catch(err => {
          console.log(err)
        })
      }
    },
    toRelease: function () {
      this.$router.push({
        path: '/task/release',
        query: {
          index: '10'
        }
      })
    },
    dealTaskData: function (id) {
      dealTask({id: id}).then(res => {
        console.log(res)
        this.$message({
          message: res.data,
          type: 'success',
          center: 'true',
          duration: '1000'
        })
        this.handleSearch()
      }).catch(err => {
        console.log(err)
      })
    },
    handleSearch: function (click) {
      this.tableData = []
      if (click === 1) {
        this.page = 1
      }
      this.loading = true
      let body = {
        startTime: this.startTime,
        endTime: this.endTime,
        page: this.page,
        rows: this.rows,
        isDeal: this.isDeal
      }
      queryTaskList(body).then(res => {
        console.log(res)
        res.data.rows && res.data.rows.map(item => {
          item.sign = 0
        })
        this.tableData = res.data.rows || []
        this.total = res.data.total
        this.loading = false
        this.all = false
        this.idList = []
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    firstPage: function () {
      console.log('首页')
      if (this.page === 1) {
        this.$message({
          message: '当前为第一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        this.page = 1
        this.handleSearch()
      }
    },
    previousPage: function () {
      console.log('上一页')
      if (this.page < 2) {
        this.$message({
          message: '当前为第一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        this.page--
        this.handleSearch()
      }
    },
    nextPage: function () {
      console.log('下一页')
      if (parseInt(this.total / this.rows) + 1 > this.page) {
        this.page++
        this.handleSearch()
      } else {
        this.$message({
          message: '当前为最后一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      }
    },
    lastPage: function () {
      console.log('尾页')
      if (this.page === parseInt(this.total / this.rows) + 1) {
        this.$message({
          message: '当前为最后一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        if (Math.round(this.total % this.rows) === 0) {
          this.page = parseInt(this.total / this.rows)
        } else {
          this.page = parseInt(this.total / this.rows) + 1
        }
        this.handleSearch()
      }
    }
  }
}
</script>

<style scoped>
  @import "Task.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/task/Task.vue